module.exports = __webpack_public_path__ + "img/blacklabel-logo-light.f30f9082.svg";